import React, { useRef, useState, useEffect } from "react";
import FloatingBanner from "../../../components/FloatingBanner";
import { freepassList, pricingList } from "../../../data/pricingClass";
import * as S from "./styled";
import AOS from "aos";
import { Helmet } from "react-helmet-async";

const PricingClass = () => {
  const pricingRef = useRef<HTMLDivElement>(null);
  const freepassRef = useRef<HTMLDivElement>(null);
  const classRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [activeSection, setActiveSection] = useState<
    "pricing" | "freepass" | "class" | null
  >("pricing");

  const [scrollHeight, setScrollHeight] = useState<number>(180);

  const handleScroll = () => {
    if (
      wrapperRef.current &&
      pricingRef.current &&
      classRef.current &&
      freepassRef.current
    ) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const freepassRect = freepassRef.current.getBoundingClientRect();
      const pricingRect = pricingRef.current.getBoundingClientRect();

      if (
        pricingRect.top >= wrapperRect.top &&
        pricingRect.bottom > scrollHeight
      ) {
        setActiveSection("pricing");
      } else if (
        freepassRect.top >= wrapperRect.top &&
        freepassRect.bottom > scrollHeight
      ) {
        setActiveSection("freepass");
      } else {
        setActiveSection("class");
      }
    }
  };

  useEffect(() => {
    const updateScrollHeight = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1024) {
        setScrollHeight(180);
      } else if (screenWidth >= 768) {
        setScrollHeight(160);
      } else {
        setScrollHeight(120);
      }
    };

    updateScrollHeight();
    window.addEventListener("resize", updateScrollHeight);

    return () => {
      window.removeEventListener("resize", updateScrollHeight);
    };
  }, []);

  const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const sectionPosition =
        ref.current.getBoundingClientRect().top + window.scrollY; // 섹션 위치 계산
      window.scrollTo({
        top: sectionPosition - scrollHeight + 5,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      AOS.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>넵튠 댄스 스튜디오 | 셔플 풋워크 전문 학원</title>

        <meta
          name="description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />

        <meta
          name="keywords"
          content="넵튠, 넵튠 댄스, 넵튠 댄스 스튜디오, 셔플, 셔플댄스학원, 댄스자격증, 풋워크 수업, 국제실용댄스지도자협회, 국제실용댄스, 풋워크"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://neptunedance.com" />
        <meta
          property="og:image"
          content="http://neptunedance.com/og-image.png"
        />
      </Helmet>
      <S.PricingClassWrapper ref={wrapperRef}>
        <div className="inner">
          <S.PricingClassWrap>
            <S.PricingClassNavList>
              <li
                onClick={() => {
                  scrollToSection(pricingRef);
                }}
                className={activeSection === "pricing" ? "active" : ""}
              >
                수강료
              </li>
              <li
                onClick={() => {
                  scrollToSection(freepassRef);
                }}
                className={activeSection === "freepass" ? "active" : ""}
              >
                프리패스
              </li>
              <li
                onClick={() => {
                  scrollToSection(classRef);
                }}
                className={activeSection === "class" ? "active" : ""}
              >
                수업 소개
              </li>
            </S.PricingClassNavList>
            <S.PricingWrap ref={pricingRef}>
              <div className="title-area">
                <h6
                  data-aos="fade-right"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  PRICING
                </h6>
                <p
                  data-aos="fade-right"
                  data-aos-delay={200}
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  수강료
                </p>
              </div>
              <S.PricingListWrap
                data-aos="fade-left"
                data-aos-delay={200}
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                {pricingList.map((pricing, index) => (
                  <>
                    <li key={pricing.type}>
                      <dl>
                        <dt className={`${index === 0 ? "grey" : "black"}`}>
                          {pricing.type}
                        </dt>
                        {pricing.class.map((classList, classListIndex) => (
                          <>
                            <div>
                              <div>
                                <p>
                                  {classList.mainTitle}
                                  {classList.mainTitleDesc && (
                                    <>
                                      <br />
                                      {classList.mainTitleDesc}
                                    </>
                                  )}
                                </p>
                                <ul key={classList.mainTitle}>
                                  {classList.course.map((item) => (
                                    <li key={item.subTitle}>
                                      <div>
                                        <p>{item.subTitle}</p>
                                      </div>
                                      <span>{item.price}</span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              {index === 1 && classListIndex === 1 && (
                                <p className="sub-text">
                                  4인이상 부터 1명당 3만원씩 추가 (9인 이상은
                                  상담신청)
                                </p>
                              )}
                            </div>
                          </>
                        ))}
                      </dl>
                    </li>
                    {index === 0 && (
                      <>
                        <p>*셔플 수업은 선착순 정원 마감되는 수업입니다.</p>
                        <p>
                          *3주차 재등록 기간 → 4회 수업만 우선 등록 가능/1회
                          수강은 대기 후, 정원이 남는 경우에만 신청 가능
                        </p>
                      </>
                    )}
                  </>
                ))}
                <li className="mt-40">
                  <dl>
                    <dt className="black">전문인 양성과정</dt>
                    <div>
                      <div>
                        <p>입시 / 오디션 / 자격증반</p>
                        <ul>
                          <li>
                            <div>
                              <p>학원으로 문의</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </dl>
                </li>
              </S.PricingListWrap>
            </S.PricingWrap>
            <S.PricingWrap ref={freepassRef}>
              <div className="title-area">
                <h6
                  data-aos="fade-right"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  FREE PASS
                </h6>
                <p
                  data-aos="fade-right"
                  data-aos-delay={200}
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  수강료
                </p>
              </div>
              <S.FreepassListWrap
                data-aos="fade-left"
                data-aos-delay={200}
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                {freepassList.map((freepass, index) => (
                  <>
                    <li key={freepass.type}>
                      <dl>
                        <dt className={`${index === 0 ? "grey" : "black"}`}>
                          {freepass.type}
                        </dt>
                        <div className="list-wrapper">
                          <div className="list-wrap">
                            {freepass.class.map((classList, classListIndex) => (
                              <>
                                <div>
                                  <div>
                                    <p>{classList.mainTitle}</p>
                                    <ul key={classList.mainTitle}>
                                      {classList.course.map((item) => (
                                        <li key={item.subTitle}>
                                          <div>
                                            <p>
                                              {item.subTitle}
                                              {item.subTitleDesc && (
                                                <>
                                                  <br />
                                                  {item.subTitleDesc}
                                                </>
                                              )}
                                            </p>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  {index === 1 && classListIndex === 1 && (
                                    <p className="sub-text">
                                      4인이상 부터 1명당 3만원씩 추가 (10인
                                      이상은 상담신청)
                                    </p>
                                  )}
                                </div>
                              </>
                            ))}
                          </div>
                          <div className="price-text-wrap">
                            {/* <p>44만원</p>
                          <span>▼</span> */}
                            <div className="text-wrap">
                              {/* <span>회원가</span> */}
                              <h6>40만원</h6>
                            </div>
                          </div>
                        </div>
                      </dl>
                    </li>
                    {index === 0 && (
                      <>
                        <p>
                          *셔플 레벨 3,4는 제외 입니다. <br />
                          (셔플 레벨 3,4 는 인원마감이 빨리되는 정원제 수업으로
                          프리패스가 불가합니다)
                        </p>
                      </>
                    )}
                  </>
                ))}
                <li className="mt-40 sale-wrap">
                  <dl>
                    <dt className="black">수업 등록별 할인 적용</dt>
                    <ul className="sale-list-wrap">
                      <li>
                        <div className="text-wrap">
                          <p className="red">
                            프리패스 등록 + 셔플 레벨4 수업 등록시
                          </p>
                          <span>셔플 수업 10% 할인 적용</span>
                        </div>
                      </li>
                      <li>
                        <div className="text-wrap">
                          <p>3개 수업 등록시 (1달)</p>
                          <span>10% 할인 적용</span>
                        </div>
                      </li>
                      <li>
                        <div className="text-wrap">
                          <p>
                            CHALLENGE : 셔플, 스트릿 수업 3개월 연속 수강 시
                          </p>
                          <span>정규수업 1회 수강권 지급</span>
                        </div>
                        <p className="info-msg">
                          *프리패스는 챌린지 할인에서 제외됩니다
                        </p>
                      </li>
                    </ul>
                  </dl>
                </li>
                <p>*중복할인 불가 (할인율이 높은 걸로 적용됩니다)</p>
              </S.FreepassListWrap>
            </S.PricingWrap>
            <S.ClassWrap ref={classRef}>
              <div className="title-area">
                <h6
                  data-aos="fade-right"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  CLASS
                </h6>
                <p
                  data-aos="fade-right"
                  data-aos-delay={200}
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  수업 소개
                </p>
              </div>
              <S.ClassListWrap
                data-aos="fade-left"
                data-aos-delay={200}
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <li className="full">
                  <h6>
                    춤을 아예 처음 접하시는 분들
                    <br />
                    몸의 움직임, 기본기부터 제대로 다지고 싶으신 분들
                  </h6>
                  <div>
                    <dl>
                      <dt>기초 기본기 트레이닝</dt>
                      <dd></dd>
                    </dl>
                    <dl>
                      <dt>셔플 LV.1</dt>
                    </dl>
                    <dl>
                      <dt>시니어 셔플</dt>
                    </dl>
                  </div>
                </li>
                <li className="half">
                  <h6>
                    춤을 어렵지 않은 난이도에서 <br />
                    멋지게 배우고 싶은 분들
                  </h6>
                  <div>
                    <dl className="half">
                      <dt>셔플 LV. 1-2</dt>
                      <dd></dd>
                    </dl>

                    <dl className="half">
                      <dt>힙합 비기너</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>기초 기본기 트레이닝</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>하우스 비기너</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>레트로 케이팝</dt>

                      <dd></dd>
                    </dl>
                  </div>
                </li>
                <li className="half">
                  <h6>
                    보다 심도있게
                    <br />
                    배우고 싶으신 분들
                  </h6>
                  <div>
                    <dl className="half">
                      <dt>힙합 비기너</dt>
                      <dd></dd>
                    </dl>

                    <dl className="half">
                      <dt>힙합 레벨업</dt>
                      <dd></dd>
                    </dl>

                    <dl className="half">
                      <dt>셔플&풋워크 LV. 3-4</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>풋워크 테크닉</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>하우스 비기너</dt>
                      <dd></dd>
                    </dl>
                  </div>
                </li>
                <li className="full">
                  <h6>전문적인 진로를 생각하시는 분들</h6>
                  <div>
                    <dl className="half">
                      <dt>오디션반</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>입시반</dt>
                      <dd></dd>
                    </dl>
                    <dl className="half">
                      <dt>장르별 수업</dt>
                    </dl>
                    <dl className="half">
                      <dt>전문 자격증 과정 (모집기간 문의)</dt>
                    </dl>
                  </div>
                </li>
              </S.ClassListWrap>
            </S.ClassWrap>
          </S.PricingClassWrap>
        </div>

        <FloatingBanner
          linkTo="http://pf.kakao.com/_xdxcJZn"
          text="수강 등록하기"
          target="_blank"
        />
      </S.PricingClassWrapper>
    </>
  );
};

export default PricingClass;
